export default __webpack_public_path__ + "static/media/milton1.2d16f535.png";